import { MediaImage } from "../types/MediaImage";
import { dates } from "./date"
import { sendGoogleTagManagerCustomEvent } from "./google"

interface NewsItem {
  excerpt: string;
  uri: string;
  slug: string;
  title: string;
  databaseId: number;
  featuredImage: MediaImage;
  date: Date;
  modified: Date;
  author: {
    node: {
      name: string;
    }
  }
}

export const gaEvents = {
    blog: {
        search: (term: string) => {
            const _eventParams = {
                term
            }
            sendGoogleTagManagerCustomEvent('search', _eventParams)
        },
        generateLead: (action: string) => {
            const _eventParams = {
                action
            }
            sendGoogleTagManagerCustomEvent('generate_lead', _eventParams)
        }
    },
    news: {
        selectArticle: (item: NewsItem) => {
            const _createdAt = dates(item.date)
            const _modifiedAt = dates(item.modified)
            const _eventParams = {
                titulo: item.title,
                data_de_criacao: _createdAt.dateFormat,
                hora_de_criacao: _createdAt.hour,
                data_de_atualizacao: _modifiedAt.dateFormat,
                hora_de_atualizacao: _modifiedAt.hour,
                id_materia: item.databaseId,
                autor: item.author.node.name
            }
            sendGoogleTagManagerCustomEvent('select_article', _eventParams)
        }
    }
}